'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * It allows adding plugins to Dekk.
 * Plugins do not render anything.
 * Plugins usually use the Component lifecycle (componentWillMount etc.)
 * to their advantage.
 *
 * @public
 * @param {Object} props
 *   The properties
 * @param {(ReactElement|ReactElement[])} props.children
 *   One or more plugins
 * @example
 * import Deck, {Plugins} from '@dekk/deck'
 * import Url from '@dekk/url'
 * import Paging from '@dekk/paging'
 *
 * export default (
 *   <Deck>
 *     <Plugins>
 *       <Url/>
 *       <Paging/>
 *     </Plugins>
 *   </Deck>
 * )
 */
var Plugins = function Plugins(props) {
  return props.children;
};

/**
 * @private
 */
Plugins.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
};

exports.default = Plugins;
//# sourceMappingURL=index.js.map